/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowRampLeft2 = createReactComponent("arrow-ramp-left-2", "IconArrowRampLeft2", [
  ["path", { d: "M18 3v8.707", key: "svg-0" }],
  ["path", { d: "M8 14l-4 -4l4 -4", key: "svg-1" }],
  ["path", { d: "M18 21c0 -6.075 -4.925 -11 -11 -11h-3", key: "svg-2" }]
]);

export { IconArrowRampLeft2 as default };
//# sourceMappingURL=IconArrowRampLeft2.js.map
